import { NavigationProp, useNavigation } from "@react-navigation/native";
import { usePreviewMode } from "../../../contexts/PreviewModeContext";
import { RootStackParamList } from "../../../navigation/AppNavigator.web";
import PreviewModeBanner from "../../../components/adminDashboard/PreviewModeBanner";
const PreviewModeBannerContainer = () => {
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const { previewReturnInfo, exitPreviewMode } = usePreviewMode();

  if (!previewReturnInfo) return null;

  const handleBackToAdmin = () => {
    exitPreviewMode();
    navigation.navigate("Course Information", {
      courseId: previewReturnInfo.courseId,
      courseName: previewReturnInfo.courseName,
    });
  };

  return <PreviewModeBanner courseName={previewReturnInfo.courseName} onBackToAdmin={handleBackToAdmin} />;
};

export default PreviewModeBannerContainer;
